import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';

import { environment } from '../../../environments/environment';

import { ApiService } from './api.service';

export interface MindHpItem {
  hp: number;
  buildingID: number;
  buildingType: string;
  hpStatus: string;
  hpEngineering: string;
  number: string;
  complement: string;
}

@Injectable({
  providedIn: 'root',
})
export class MindHpsService {
  private readonly baseUrl = `${environment.externalGateServiceUrl}/mind/hps`;
  private apiService = inject(ApiService);


  getHps(cep: string, number: string): Observable<MindHpItem[]> {
    const cleanCep = (cep || '').replace(/\D/g, '');
    const cleanNumber = (number || '').replace(/\D/g, '') || number;
    if (!cleanCep || !cleanNumber) {
      return of([]);
    }
    const url = `${this.baseUrl}/${cleanCep}/${cleanNumber}`;
    return this.apiService.getExternal<MindHpItem[]>(url).pipe(
      catchError((err) => {
        console.error('[MindHpsService] Erro ao buscar HPs:', err);
        return of([]);
      })
    );
  }
}
